import { AlertTriangle, CheckCircle2, CircleSlash2, Gauge } from "lucide-react";
import type { QualityStatus } from "../features/dashboard/types";

const qualityConfig = {
  good: {
    label: "Good quality",
    className: "border-positive/30 bg-positive/10 text-positive",
    icon: CheckCircle2,
  },
  partial: {
    label: "Partial coverage",
    className: "border-warning/35 bg-warning/10 text-warning",
    icon: AlertTriangle,
  },
  "low-quality": {
    label: "Low quality",
    className: "border-negative/35 bg-negative/10 text-negative",
    icon: Gauge,
  },
  unavailable: {
    label: "Unavailable",
    className: "border-divider bg-inset/60 text-muted",
    icon: CircleSlash2,
  },
} as const;

interface QualityBadgeProps {
  readonly status: QualityStatus;
  readonly label?: string;
}

export function QualityBadge({ status, label }: QualityBadgeProps) {
  const config = qualityConfig[status];
  const Icon = config.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${config.className}`}
    >
      <Icon aria-hidden="true" className="h-3.5 w-3.5" />
      {label ?? config.label}
    </span>
  );
}
